import React, { useState } from 'react';
import { meApi } from '../services/api';
import { useAuth } from '../context/AuthContext';

/** The signed-in operator's account: who they are, and their password. */
const SettingsPage: React.FC = () => {
  const { user, logout } = useAuth();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [state, setState] = useState<{ kind: 'idle' | 'saving' | 'saved' } | { kind: 'error'; msg: string }>({ kind: 'idle' });

  const change = async (e: React.FormEvent) => {
    e.preventDefault();
    if (next.length < 8) return setState({ kind: 'error', msg: 'The new password needs at least 8 characters.' });
    setState({ kind: 'saving' });
    try {
      await meApi.changePassword(current, next);
      setCurrent('');
      setNext('');
      setState({ kind: 'saved' });
    } catch (err: any) {
      setState({
        kind: 'error',
        msg: err?.response?.status === 403
          ? "That current password isn't right, or this account has no password yet — ask an admin to set one."
          : err?.response?.data?.detail || err.message,
      });
    }
  };

  return (
    <div className="w-full px-7 pt-6 pb-16">
      <div className="page-head">
        <div>
          <h1 className="page-title">Settings</h1>
          <p className="page-sub">Your account on the portal and in the Nurture app</p>
        </div>
      </div>

      <div className="space-y-3.5 max-w-2xl">
        <div className="card">
          <h3 className="card-h">Profile</h3>
          <div className="kv"><span>Name</span><span>{user?.name || '—'}</span></div>
          <div className="kv"><span>Email</span><span>{user?.email}</span></div>
          <div className="kv"><span>Phone</span><span className="num">{user?.phone || '—'}</span></div>
          <div className="kv"><span>Role</span><span className="capitalize">{user?.role}</span></div>
        </div>

        <form className="card" onSubmit={change}>
          <h3 className="card-h">Change password</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <label className="block">
              <span className="block text-xs text-graphite mb-1">Current password</span>
              <input id="pw-current" className="inp w-full" type="password" autoComplete="current-password"
                value={current} onChange={(e) => setCurrent(e.target.value)} />
            </label>
            <label className="block">
              <span className="block text-xs text-graphite mb-1">New password</span>
              <input id="pw-new" className="inp w-full" type="password" autoComplete="new-password" placeholder="At least 8 characters"
                value={next} onChange={(e) => setNext(e.target.value)} />
            </label>
          </div>
          <div className="flex items-center gap-3 mt-3">
            <button className="btn btn-pri" type="submit" disabled={!current || !next || state.kind === 'saving'}>
              {state.kind === 'saving' ? 'Saving…' : 'Change password'}
            </button>
            {state.kind === 'saved' && <span className="text-forest text-[13px]">Password changed.</span>}
            {state.kind === 'error' && <span className="text-brick text-[13px]">{state.msg}</span>}
          </div>
        </form>

        <div className="card flex items-center justify-between">
          <span className="text-[13px] text-graphite">Signed in as {user?.email}</span>
          <button className="btn" onClick={logout}>Sign out</button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
